var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2017_905",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2017_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.175 19.575V16.425H21.85V19.575H9.175ZM9.175 13.575V10.425H21.85V13.575H9.175ZM9.175 7.57501V4.42501H21.85V7.57501H9.175ZM4.644 20.525C3.948 20.525 3.35417 20.2772 2.8625 19.7815C2.37083 19.2858 2.125 18.69 2.125 17.994C2.125 17.298 2.37283 16.7042 2.8685 16.2125C3.36417 15.7208 3.96 15.475 4.656 15.475C5.352 15.475 5.94583 15.7228 6.4375 16.2185C6.92917 16.7142 7.175 17.31 7.175 18.006C7.175 18.702 6.92717 19.2958 6.4315 19.7875C5.93583 20.2792 5.34 20.525 4.644 20.525ZM4.644 14.525C3.948 14.525 3.35417 14.2772 2.8625 13.7815C2.37083 13.2858 2.125 12.69 2.125 11.994C2.125 11.298 2.37283 10.7042 2.8685 10.2125C3.36417 9.72084 3.96 9.47501 4.656 9.47501C5.352 9.47501 5.94583 9.72284 6.4375 10.2185C6.92917 10.7142 7.175 11.31 7.175 12.006C7.175 12.702 6.92717 13.2958 6.4315 13.7875C5.93583 14.2792 5.34 14.525 4.644 14.525ZM4.644 8.52501C3.948 8.52501 3.35417 8.27717 2.8625 7.78151C2.37083 7.28584 2.125 6.69001 2.125 5.99401C2.125 5.29801 2.37283 4.70417 2.8685 4.21251C3.36417 3.72084 3.96 3.47501 4.656 3.47501C5.352 3.47501 5.94583 3.72284 6.4375 4.21851C6.92917 4.71417 7.175 5.31001 7.175 6.00601C7.175 6.70201 6.92717 7.29584 6.4315 7.78751C5.93583 8.27917 5.34 8.52501 4.644 8.52501Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.94be9d1e9767a1608210e6fca23ef84e.svg";
export { ForwardRef as ReactComponent };